import React from 'react';
import styled from 'styled-components';

interface Props {
  className?: string;
  title: string;
  children: React.ReactNode;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  width: 700px;
  border-radius: 14px;
`;

const Content = styled.div`
  text-align: left;
`;

const ExceedTimeLimitPanel = (props: Props) => (
  <Wrapper className={props.className}>
    <h2>{props.title}</h2>
    <Content>
      {props.children}
    </Content>
  </Wrapper>
);

export default ExceedTimeLimitPanel;
